"use client";

import React from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../services/store";

export default observer(function HeaderControls() {
  const store = useStore();

  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        display: "flex",
        gap: "0.25rem",
        zIndex: 1000,
        background: "rgba(0, 0, 0, 0.8)",
        borderRadius: "8px",
        padding: "8px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
        backdropFilter: "blur(8px)",
      }}
    >
      {store.isAdminParam && (
        <button
          type="button"
          onClick={() => store.setAllowSignal(!store.allowSignal)}
          aria-pressed={store.allowSignal}
          className="dib bn br2 pa1 ph2 f6 fw6 pointer transition-all"
          title="Signal actions"
          style={{
            background: "#000",
            color: "#fff",
            opacity: store.allowSignal ? 0.7 : 0.25,
            touchAction: "manipulation",
          }}
        >
          ⚡
        </button>
      )}

      <button
        type="button"
        onClick={() => store.setAllowDrillDown(!store.allowDrillDown)}
        aria-pressed={store.allowDrillDown}
        className="dib bn br2 pa1 ph2 f6 fw6 pointer transition-all"
        title="Allow drill down into sectors"
        style={{
          background: "#000",
          color: "#fff",
          opacity: store.allowDrillDown ? 0.7 : 0.25,
          touchAction: "manipulation",
        }}
      >
        🔍
      </button>

      <button
        type="button"
        onClick={() => store.setShowEROnly(!store.showEROnly)}
        aria-pressed={store.showEROnly}
        className="dib bn br2 pa1 ph2 f6 fw6 pointer transition-all"
        title="Show only symbols with earnings dates"
        style={{
          background: "#000",
          color: "#fff",
          opacity: store.showEROnly ? 0.7 : 0.25,
          touchAction: "manipulation",
        }}
      >
        E
      </button>

      <button
        type="button"
        onClick={() => store.toggleMarketCapFilter()}
        aria-pressed={store.isMarketCapFilter}
        className="dib bn br2 pa1 ph2 f6 fw6 pointer transition-all"
        title="Filter by market cap"
        style={{
          background: "#000",
          color: "#fff",
          opacity: store.isMarketCapFilter ? 0.7 : 0.25,
          touchAction: "manipulation",
        }}
      >
        M
      </button>
      {/* 
      <button
        type="button"
        onClick={() => store.toggleSectorSymbolsSort()}
        aria-pressed={store.sectorSymbolsSortByStrength}
        className="dib bn br2 pa1 ph2 f6 fw6 pointer transition-all"
        title={
          store.sectorSymbolsSortByStrength
            ? "Sort by strongest moves"
            : "Group by sector"
        }
        style={{
          background: "#000",
          color: "#fff",
          opacity: store.sectorSymbolsSortByStrength ? 0.7 : 0.25,
          touchAction: "manipulation",
        }}
      >
        G
      </button>
      */}
      <button
        type="button"
        onClick={() => store.setCut(!store.cut)}
        aria-pressed={store.cut}
        className="dib bn br2 pa1 ph2 f6 fw6 pointer transition-all"
        title={
          store.cut
            ? "Show full chart history"
            : "Cut chart at selected date"
        }
        style={{
          background: "#000",
          color: "#fff",
          opacity: store.cut ? 0.7 : 0.25,
          touchAction: "manipulation",
        }}
      >
        *
      </button>

      <button
        type="button"
        onClick={() => store.toggleFilterByPercentageThreshold()}
        aria-pressed={store.filterByPercentageThreshold}
        className="dib bn br2 pa1 ph2 f6 fw6 pointer transition-all"
        title={
          store.filterByPercentageThreshold
            ? "Show all percentage changes"
            : "Filter by >10% change"
        }
        style={{
          background: "#000",
          color: "#fff",
          opacity: store.filterByPercentageThreshold ? 0.7 : 0.25,
          touchAction: "manipulation",
        }}
      >
        F
      </button>

      <button
        type="button"
        onClick={() => store.toggleShowPattern()}
        aria-pressed={store.showPattern}
        className="dib bn br2 pa1 ph2 f6 fw6 pointer transition-all"
        title="Show pattern text in percentage mode"
        style={{
          background: "#000",
          color: "#fff",
          opacity: store.showPattern ? 0.7 : 0.25,
          touchAction: "manipulation",
        }}
      >
        P
      </button>

      {
        <button
          type="button"
          onClick={() => store.togglePercentSortOrder()}
          aria-pressed={!store.percentSortDesc}
          className="dib bn br2 pa1 ph2 f6 fw6 pointer transition-all"
          title={store.percentSortDesc ? "Sort ascending" : "Sort descending"}
          style={{
            background: "#000",
            color: "#fff",
            opacity: store.percentSortDesc ? 0.25 : 0.7,
            touchAction: "manipulation",
          }}
        >
          -
        </button>
      }

      {
        <button
          type="button"
          onClick={() => store.toggleStrongSort()}
          aria-pressed={store.strongSort}
          className="dib bn  pa1 ph2 f6 fw6 pointer transition-all"
          title="Sort by percent change"
          style={{
            background: "#000",
            color: "#fff",
            opacity: store.strongSort ? 0.7 : 0.25,
            touchAction: "manipulation",
          }}
        >
          ↑
        </button>
      }

      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          store.setIsPercent(!store.isPercent);
        }}
        onTouchStart={(e) => {
          e.preventDefault();
        }}
        onTouchEnd={(e) => {
          e.preventDefault();
          e.stopPropagation();
          store.setIsPercent(!store.isPercent);
        }}
        aria-pressed={store.isPercent}
        className="dib bn br2 pa1 ph2 f6 fw6 pointer transition-all"
        title="Percentage mode"
        style={{
          background: "#000",
          color: "#fff",
          opacity: store.isPercent ? 0.7 : 0.25,
          touchAction: "manipulation",
        }}
      >
        %
      </button>
    </div>
  );
});
